import { render, staticRenderFns } from "./knowledgeBaseList.vue?vue&type=template&id=149b8a1c&scoped=true&"
import script from "./knowledgeBaseList.vue?vue&type=script&lang=js&"
export * from "./knowledgeBaseList.vue?vue&type=script&lang=js&"
import style0 from "./knowledgeBaseList.vue?vue&type=style&index=0&id=149b8a1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149b8a1c",
  null
  
)

export default component.exports